import axios from '@/lib/AxApi';

export default
{
  async exportData(params, cb)
  {
    window.open('/ExportReports/exportData?query=' + JSON.stringify(params));
  }
}